import { useMemo } from 'react';
import type { EventDetailsResponse } from '@/features/events/types/types';

interface GalleryItem {
    id: string;
    type: 'image' | 'video';
    url: string;
}

export const useEventGallery = (eventDetails: EventDetailsResponse | null): GalleryItem[] => {
    return useMemo(() => {
        if (!eventDetails?.data?.event) return [];

        const items: GalleryItem[] = [];
        const eventInfo = eventDetails.data.event;

        // Add video if available
        if (eventInfo.card_video_id && eventInfo.card_video_id !== '00000000-0000-0000-0000-000000000000') {
            items.push({
                id: 'card_video',
                type: 'video' as const,
                url: eventInfo.card_video_id
            });
        }

        // Add media images
        if (eventInfo.media) {
            const sortedMedia = [...eventInfo.media].sort((a, b) => (a.rank || 0) - (b.rank || 0));
            sortedMedia.forEach(media => {
                if (media.media_id && media.media_id !== '00000000-0000-0000-0000-000000000000') {
                    items.push({
                        id: media.media_id,
                        type: 'image' as const,
                        url: media.media_id
                    });
                }
            });
        }

        return items;
    }, [eventDetails]);
};
